/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/Dashboard.js";
import Preparation from "views/Preparation.js";
import TableList from "views/Tables.js";
import Diary from "views/diary/Diary.js";
import UserPage from "views/User.js";
import Logout from "views/Logout.js";
import Analysis from "views/Analysis.js";
import Aphorisms from "views/Aphorisms.js";
import Goalsetting from "views/Goalsetting.js";
import BigGoalsetting from "views/BigGoalsetting.js";
import ChatRoom from "views/ChatRoom.js";
import Members from "views/Members.js";
import Evaluation from "views/Evaluation.js";
// import Sample from "views/Sample.js";

import evaluationImg from "assets/img/sidebar/evaluation.png";
import tablesImg from "assets/img/sidebar/tables.png";
import bigGoalsettingImg from "assets/img/sidebar/bigGoalsetting.png";
import diaryImg from "assets/img/sidebar/diary.png";
import aphorismsImg from "assets/img/sidebar/aphorisms.png";
import preparationImg from "assets/img/sidebar/preparation.png";
import goalsettingImg from "assets/img/sidebar/goalsetting.png";
import chatImg from "assets/img/sidebar/chat.png";
import profileImg from "assets/img/sidebar/profile.png";
import logoutImg from "assets/img/sidebar/logout.png";
import analysisImg from "assets/img/sidebar/analysis.png";

var routes = [  
  // {
  //   path: "/sample",
  //   name: "ダッシュボード",
  //   icon: "nc-icon nc-chart-pie-36",
  //   component: Sample,
  //   layout: "/admin",
  // },
  {
    path: "/user-page",
    name: "プロフィール編集",
    icon: "nc-icon nc-single-02",
    onImg:true,
    img:profileImg,
    component: UserPage,
    layout: "/admin",
  }, 
  {
    path: "/evaluation",
    name: "コーチからの評価",
    icon: "nc-icon nc-user-run",
    onImg:true,
    img:evaluationImg,
    component: Evaluation,
    layout: "/admin",
  }, 
  {
    path: "/analysis",
    name: "自己分析",
    icon: "nc-icon nc-chart-bar-32",
    onImg:true,
    img:analysisImg,
    component: Analysis,
    layout: "/admin",
  },
  {
    path: "/biggoalsetting",
    name: "大会目標",
    icon: "nc-icon nc-air-baloon",
    onImg:true,
    img:bigGoalsettingImg,
    component: BigGoalsetting,
    layout: "/admin",
  },
  {
    path: "/goalsetting",
    name: "課題目標",
    icon: "nc-icon nc-vector",
    onImg:true,
    img:goalsettingImg,
    component: Goalsetting,
    layout: "/admin",
  },
  
  {
    path: "/diary",
    name: "日記",
    icon: "nc-icon nc-user-run",
    onImg:true,
    img:diaryImg,
    component: Diary,
    layout: "/admin",
  },
  {
    path: "/preparation",
    name: "試合準備",
    icon: "nc-icon nc-bullet-list-67",
    onImg:true,
    img:preparationImg,
    component: Preparation,
    layout: "/admin",
  },  
  {
    path: "/tables",
    name: "試合後リフレクション",
    icon: "nc-icon nc-trophy",
    onImg:true,
    img:tablesImg,
    component: TableList,
    layout: "/admin",
  },
  {
    path: "/aphorisms",
    name: "格言集",
    icon: "nc-icon nc-atom",
    onImg:true,
    img:aphorismsImg,
    component: Aphorisms,
    layout: "/admin",
  },
  // {
  //   path: "/chat",
  //   name: "チャット",
  //   icon: "nc-icon nc-chat-33",
  //   component: ChatRoom,
  //   layout: "/admin",
  // }, 
  {
    path: "/members",
    name: "チャット",
    icon: "nc-icon nc-chat-33",
    onImg:true,
    img:chatImg,
    component: Members,
    layout: "/admin",
  },
  {
    path: "/logout",
    name: "ログアウト",
    icon: "nc-icon nc-share-66",
    onImg:true,
    img:logoutImg,
    component: Logout,
    layout: "/admin",
  },
  
];
export default routes;
